<div class="host__item d-flex flex-row">
    <div class="d-flex flex-row">
      <img [src]="'./assets/images/icons/profile-picture-placeholder-01.svg'" alt="profile-picture">
      <div class="host-info">
        <div><span>{{ host?.firstName }}</span>&nbsp;<span>{{ host?.lastName }}</span>&nbsp;</div>
        <div class="d-flex flex-row align-items-center">
          <mat-icon class="icon">person</mat-icon>{{'HOST.HOST_AT'|translate}} &nbsp;<span>{{company?.companyName}}</span>
          <!-- &nbsp;|&nbsp;<span>{{company?.city}}</span> -->
        </div>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-end">
      <div class="host-settings">
        <div (click)="viewHost(host?.id)" class="d-flex flex-row">
          <span>{{ 'VIEW' | translate }}</span><mat-icon style="font-size: 18px; margin-left: 5px;" class="icon">search</mat-icon>
        </div>
        <div (click)="openEditHost(host?.id)" class="d-flex flex-row">
          <span>{{ 'EDIT' | translate }}</span><mat-icon style="font-size: 18px; margin-left: 5px;" class="icon">edit</mat-icon>
        </div>
        <div (click)="deactivateHost(host?.id)" class="d-flex flex-row">
          <span>{{'DEACTIVATE'|translate}}</span><mat-icon style="font-size: 18px; margin-left: 5px;" class="icon">close</mat-icon>
        </div>
      </div>
    </div>
  </div>